import { render, staticRenderFns } from "./index - 道闸分开.vue?vue&type=template&id=24dbf587&scoped=true&"
import script from "./index - 道闸分开.vue?vue&type=script&lang=js&"
export * from "./index - 道闸分开.vue?vue&type=script&lang=js&"
import style0 from "./index - 道闸分开.vue?vue&type=style&index=0&id=24dbf587&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dbf587",
  null
  
)

export default component.exports